import { FC } from 'react';
import { IFactoid } from 'shared/types/houseInfo/factoid';
import styles from './InlineFactoidItem.css';
import { UIText1 } from '@cian/ui-kit';

export const InlineFactoidItem: FC<IFactoid> = ({ title, value }) => {
  return (
    <div className={styles['inline-factoid']}>
      <UIText1 color="gray60_100">{title}</UIText1>
      <UIText1>{value}</UIText1>
    </div>
  );
};
